export const isGloboCurrentApp = () => {
  return process.env.REACT_APP_CURRENT_APPLICATION === "GLOBO";
}

export const FontFamilyByCurrentApp = () => {
  if (process.env.REACT_APP_CURRENT_APPLICATION === "GLOBO")  {
    return '"IBM Plex Sans",-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol"';
  } 

  return '"Roboto","Montserrat"';
}

export const MuiFormLabelColorByCurrentApp = () => {
  if (process.env.REACT_APP_CURRENT_APPLICATION === "GLOBO")  {
    return '#666666';
  } 

  return '#7F7F7F';
}

export const PrimaryMainBackgroundColorByCurrentApp = () => {
  if (process.env.REACT_APP_CURRENT_APPLICATION === "GLOBO")  {
    return '#0D3EFB';
  } 

  return '#D81616';
}

export const ButtonBackgroundColorByCurrentApp = () => {
  if (process.env.REACT_APP_CURRENT_APPLICATION === "GLOBO")  {
    return '#0D3EFB';
  } 

  return '#D81616';
}

export const ButtonHoverBackgroundColorByCurrentApp = () => {
  if (process.env.REACT_APP_CURRENT_APPLICATION === "GLOBO")  {
    return '#3c2ee3';
  } 

  return '#D81616';
}

export const ButtonActiveBackgroundColorByCurrentApp = () => {
  if (process.env.REACT_APP_CURRENT_APPLICATION === "GLOBO")  {
    return '#223b6b';
  } 

  return '#D81616';
}

export const GradientBackgroundImageByCurrentApp = () => {
  if (process.env.REACT_APP_CURRENT_APPLICATION === "GLOBO")  {
    return 'linear-gradient(80deg, #4875FB, #20B9FC)';
  } 

  return 'radial-gradient(at 60% 24%, #f29100, #D81615, #f29100)';
}

export const ColorDotsByCurrentApp = () => {
  if (process.env.REACT_APP_CURRENT_APPLICATION === "GLOBO")  {
    return ' #4875FB';
  } 

  return ' #D81615';
}

export const LinkColorByCurrentApp = () => {
  if (process.env.REACT_APP_CURRENT_APPLICATION === "GLOBO")  {
    return ' #4875FB';
  } 

  return ' #D81615';
}

export const ButtonColorCurrentApp = () => {
  if (process.env.REACT_APP_CURRENT_APPLICATION === "GLOBO")  {
    return ' #0b34d7';
  } 

  return ' #D81615';
}

export const ColorDotsNotSelectedByCurrentApp = () => {
  if (process.env.REACT_APP_CURRENT_APPLICATION === "GLOBO")  {
    return ' #20B9FC)';
  } 

  return ' #f29100';
}

export const BorderButtonByCurrentApp = () => {
  if (process.env.REACT_APP_CURRENT_APPLICATION === "GLOBO")  {
    return '2px solid #A2A7AC';
  } 

  return '';
}

export const BorderButtonHoverByCurrentApp = () => {
  if (process.env.REACT_APP_CURRENT_APPLICATION === "GLOBO")  {
    return '2px solid #3d1ff3';
  } 

  return '';
}

export const BorderButtonActiveByCurrentApp = () => {
  if (process.env.REACT_APP_CURRENT_APPLICATION === "GLOBO")  {
    return '2px solid #222b6b';
  } 

  return '#';
}

export const LogoSrcByCurrentApp = () => {
  if (process.env.REACT_APP_CURRENT_APPLICATION === "GLOBO")  {
    return '2px solid #222b6b';
  } 

  return '#';
}

export const MuiContainerBackgroundColorByCurrentApp = () => {
  if (process.env.REACT_APP_CURRENT_APPLICATION === "GLOBO")  {
    return '';
  } 

  return '#E5E5E5';
}

export const MuiFormLabelFilledColorByCurrentApp = () => {
  if (process.env.REACT_APP_CURRENT_APPLICATION === "GLOBO")  {
    return '#333333;';
  } 

  return '#7F7F7F';
}

export const SvgIconFillColorByCurrentApp = () => {
  if (process.env.REACT_APP_CURRENT_APPLICATION === "GLOBO")  {
    return '#3c2ee3';
  } 

  return '#D81616';
}

export const SvgIconFillColorOpenByCurrentApp = () => {
  if (process.env.REACT_APP_CURRENT_APPLICATION === "GLOBO")  {
    return '#222223db';
  } 

  return '#D81616';
}

export const UserIconBoxShadowByCurrentApp = () => {
  if (process.env.REACT_APP_CURRENT_APPLICATION === "GLOBO")  {
    return '0px 1px 4px #1e66d175';
  } 

  return '0px 1px 4px #D81616';
}

export const UserIconBoxShadowHoverByCurrentApp = () => {
  if (process.env.REACT_APP_CURRENT_APPLICATION === "GLOBO")  {
    return '0px 1px 4px #0000009c';
  } 

  return '0px 1px 4px #D81616';
}


export const SearchWrapperBorderRadiusByCurrentApp = () => {
  if (process.env.REACT_APP_CURRENT_APPLICATION === "GLOBO")  {
    return '4px !important';
  } 

  return '8px !important';
}

export const AudioCardBackgroundImagegByCurrentApp = () => {
  if (process.env.REACT_APP_CURRENT_APPLICATION === "GLOBO")  {
    return 'linear-gradient(80deg,#4875FB,#20B9FC)';
  } 

  return 'linear-gradient(80deg,#E94E1B, #E94E1B)';
}

export const CircularProgressColorByCurrentApp = () => {
  if (process.env.REACT_APP_CURRENT_APPLICATION === "GLOBO")  {
    return '#0D3EFB';
  } 

  return '#D81616 !important';
}

export const ChangePasswordButtonBackgroundColorByCurrentApp = () => {
  if (process.env.REACT_APP_CURRENT_APPLICATION === "GLOBO")  {
    return '#3c2ee3';
  } 

  return '#D81616';
}

export const SvgIconWidthByCurrentApp = () => {
  if (process.env.REACT_APP_CURRENT_APPLICATION === "GLOBO")  {
    return '11rem';
  } 

  return '90%';
}